import { offToleranceMessage } from '@app/modules/audit/modules/station-audit/components/schedule/schedule-match-details.messages';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

/**
 * Caption warning with amber icon when a match confirmation is outside tolerance.
 */
export function ScheduleOffToleranceWarning() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        color: 'warning.main',
      }}
    >
      <WarningAmberIcon fontSize="small" />
      <Typography variant="caption" color="inherit">
        <FormattedMessage {...offToleranceMessage} />
      </Typography>
    </Box>
  );
}
